import React, { useEffect, useState } from "react";
import { callBackend } from "../utils/api";
import { ShieldAlert, Clock } from "lucide-react";

export default function RaidLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    callBackend("/history/raids").then(setLogs);
  }, []);

  return (
    <div className="bg-zinc-900 border-2 border-orange-900/40 p-6 shadow-2xl font-mono">
      <h3 className="text-orange-600 font-black italic mb-4 uppercase flex items-center gap-2">
        <ShieldAlert size={18} /> Federal Intervention Records
      </h3>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {logs.length === 0 && (
          <p className="text-zinc-600 italic text-xs">
            No active Fed reports in the current archive.
          </p>
        )}
        {logs.map((log) => (
          <div
            key={log.id}
            className="text-[10px] border-l-2 border-orange-700 pl-2 py-2 bg-black/20"
          >
            <div className="flex items-center gap-2 text-zinc-500 mb-1">
              <Clock size={10} /> {new Date(log.created_at).toLocaleString()}
            </div>
            <p className="text-red-500 font-bold uppercase">{log.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
